import React, {Component} from "react";
import Calendar from "react-calendar";
import {
    utcToLocalTime,
    currentTimeMs,
    getActiveProject,
    ATTR_DATE_AND_TIME,
    strToBool, isValueEmpty
} from "./ProsConnect";
import DropdownMenu from "../components/DropdownMenu";
import {showMandatoryAndMissingMessage} from "./ProsCommonUi";

export default class ProsDateMenu extends Component {
    constructor(props) {
        super(props)
        const timeMs = this.props.timeMs ? this.props.timeMs : currentTimeMs()
        this.state = {
            timeMs: timeMs,
            clockMs: timeMs - this.getStartOfDay(timeMs),
            dateSelected: isValueEmpty(this.props.timeMs)
        }
        this.showHourMin = strToBool(getActiveProject().attrs[ATTR_DATE_AND_TIME])
    }

    onChangeTime = date => {
        const midnightMs = this.getStartOfDay(date)
        const newTime = midnightMs + this.state.clockMs
        this.setState({
            timeMs: newTime,
            dateSelected: true
        })
        this.props.onChange(newTime)
    }

    timeConvert(num) {
        const h = Math.floor(num / 60).toString()
        const m = Math.round(num % 60).toString().slice(0, 2)
        return h.padStart(2, '0') + ":" + m.padStart(2, '0')
    }

    getStartOfDay =(ms)=>{
        const resetHours = new Date(ms).setHours(0,0,0,0)
        return new Date(resetHours).getTime()
    }

    renderTimeSelector =()=>{
        if ( ! this.showHourMin) {
            return null
        }
        const midnightMs = this.getStartOfDay(this.state.timeMs)
        let timesList = []
        let curVal = null
        for (let i = 0; i < 24; i += 0.5) {
            const tick = i * 3600 * 1000
            if (this.state.timeMs === (tick + midnightMs)) {
                curVal = tick
            }
            if ( ! curVal && this.state.timeMs < (tick + midnightMs)) {
                let time = this.timeConvert((this.state.timeMs - midnightMs) / 3600 / 1000 * 60)
                curVal = this.state.timeMs - midnightMs
                timesList.push({
                    value: curVal,
                    text: time
                })
            }
            let time = this.timeConvert(i * 60)
            timesList.push({
                value: tick,
                text: time
            })
        }
        return <div>
            <h6>Valitse kellonaika</h6>
            <DropdownMenu
                text={"Valitse kellonaika"}
                values={timesList}
                currentValue={curVal}
                onSelect={val => {
                    this.setState({clockMs: val, timeMs: val + midnightMs},
                        ()=> this.onChangeTime(val + midnightMs))
                }}
            />
        </div>
    }

    render() {
        const isMandatoryAndMissing = this.props.isMandatoryAndMissing || (this.props.timeMs === 0 && this.props.isMissing)
        return <>
            {showMandatoryAndMissingMessage(isMandatoryAndMissing && !this.state.dateSelected)}
            <div className={"element-set"}>
                <Calendar
                    onChange={this.onChangeTime}
                    value={utcToLocalTime(this.state.timeMs)}
                    showWeekNumbers={true}
                    locale="fi-FI"
                />
                {this.renderTimeSelector()}
            </div>
        </>
    }
}